import { useEffect, useLayoutEffect, useState } from 'react'

import { OrderFlowProperty, endOrderFlowProperty, trackOrderFlowProperty } from './orderFlowProperty'

/**
 * Stamps an order flow's events with the property they are about, for as long as the flow is mounted. Each flow
 * decides the values: the CRM's objectReferenceId and our realtyId, null while unknown.
 */
export const useOrderFlowProperty = ({ objectReferenceId, realtyId }: OrderFlowProperty) => {
  // Registered at mount, during render, not in an effect: React runs descendant effects before this one, so the
  // first order_flow_loaded would otherwise fire without the property (same reason as useOrderAttempt).
  const [owner] = useState(() => {
    const flow = Symbol('order-flow-property')
    trackOrderFlowProperty(flow, { objectReferenceId, realtyId })
    return flow
  })

  // A layout effect, so a change is registered before the passive effects of the same commit, where steps log.
  useLayoutEffect(() => {
    trackOrderFlowProperty(owner, { objectReferenceId, realtyId })
  }, [owner, objectReferenceId, realtyId])

  useEffect(() => () => endOrderFlowProperty(owner), [owner])
}
